<template>
    <div class="w-full">
        <onboarding-header :current-step="2" :total-steps="3">
            <template v-slot:header>
                Update your profile
            </template>
            <template v-slot:description>
                Make yourself easier to identify for team mates.
            </template>
        </onboarding-header>

        <FormulateForm :values="me" @submit="updateUser" class="mt-8 max-w-screen-xs">
            <label class="text-sm text-gray-500 leading-8" for="name">Your name...</label>
            <base-input required id="name" name="name" placeholder="Enter your name..." class="mb-8" />

            <label class="text-sm text-gray-500 leading-10">Your profile image...</label>

            <FormulateInput
                    type="image"
                    name="file"
                    validation="mime:image/jpeg,image/png,image/jpg"
                    accept="mime:image/jpeg,image/png,image/jpg"
                    upload-behavior="delayed"
                    :uploader="uploadFile"
            />

            <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success dark:border-green-500" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="tick" iconPosition="left"   type="submit">Save and Continue</base-button>
        </FormulateForm>
    </div>
</template>

<script>
import OnboardingHeader from "../OnboardingHeader"
import { updateUser, uploadedProfilePicture } from "@/graphql/mutations";
import { uploadProfilePicture } from "@/graphql/queries";
import { me, loading, error } from '@/mixins'
import { BlockBlobClient } from "@azure/storage-blob";


export default {
  name: "UpdateProfile",
  metaInfo: {
      title: 'Update Your Profile',
  },
  mixins: [
      me, loading, error
  ],
  components: {
    OnboardingHeader
  },
  data () {
      return {
          isSubmitting: false,
          image: null
      }
  },
  methods: {
    async uploadFile(file, progress, error, option) {
            try {
                const presignedUrlObject = await this.$apollo.query({
                    query: uploadProfilePicture
                });


                const presignedUrl = presignedUrlObject.data.uploadProfilePicture.presignedUrl
                const blockBlobClient = new BlockBlobClient(presignedUrl);

                const uploaded = await blockBlobClient.uploadBrowserData(file, 
                { blobHTTPHeaders: 
                    { blobContentType: file.type },
                    onProgress: (function progress(event) {
                        this.markProgress(parseInt(event.loadedBytes / this.fileSize * 100));
                    }).bind({ fileSize: file.size, markProgress: progress })
                } );
                
                const uploadedUser = await this.$apollo.mutate({
                    mutation: uploadedProfilePicture,
                    variables: {}
                });
                
                return [{ url: uploadedUser.data.uploadedProfilePicture.user.profilePictureUrl }];
            } catch (error) {
                this.handleError(new Error('Unable to upload file'));
            }
        },
      async updateUser(data) {

          if (this.isSubmitting) {
              return
          }

          this.isSubmitting = true;

          try {
            const changesMade = data.name.length || data.file.length;
            
            if (changesMade) {
                this.$root.$emit('loading', true);

                await this.$apollo.mutate({
                    mutation: updateUser,
                    variables: {
                        input: {
                            name: data.name
                        }
                    },
                });
            }
            
            this.$router.push({ name: 'OnboardingInviteTeam'})
          } catch (error) {
            this.handleError(error);
          }

          this.$root.$emit('loading', false);

          this.isSubmitting = false;
      }
  }
};
</script>
